// extracted by mini-css-extract-plugin
export var testimonials = "styles-module--testimonials--3Wkhh";
export var testimonials_video = "styles-module--testimonials_video--e5CIm";